import { colors, fonts } from '@grupoboticario/flora-tokens/casaMagalhaesOutono/web/ds'

export const casaMagalhaesOutono = {
  colors,
  fonts,
}
